import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';

export interface AuthenticationState {
  idToken: IdTokenClaims | undefined;
  discoveryDocumentLoaded: boolean;
  isAuthenticated: boolean;
  authenticationInProgress: boolean;
}

export interface IdTokenClaims {
  sub: string;
  user: {
    givenName: string;
    surname: string;
  };
  email: string;
  fachinfo: string[] | undefined;
}

const initialState: AuthenticationState = {
  idToken: undefined,
  discoveryDocumentLoaded: false,
  isAuthenticated: false,
  authenticationInProgress: false,
};

export const AuthenticationStateStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(store => ({
    isAuthenticated2: computed(() => {
      return store.idToken() !== undefined;
    }),
  })),
  withMethods(store => ({
    setAuthenticationInProgress(inProgress: boolean): void {
      patchState(store, { authenticationInProgress: inProgress });
    },
    setIsAuthenticated(authenticated: boolean): void {
      patchState(store, { isAuthenticated: authenticated });
      if (!authenticated) {
        patchState(store, { idToken: undefined });
      }
    },
    setIsDiscoveryDocumentLoaded(loaded: boolean): void {
      patchState(store, { discoveryDocumentLoaded: loaded });
    },
    setIdTokenClaims(token: IdTokenClaims | undefined): void {
      patchState(store, { idToken: token });
    },
  })),
);
